import fetch from '../../../../utils/fetch'

const getInitialState = () => {
  return {
    isLoading: false,
    projects: null,
    error: null,
  }
}

const state = getInitialState();

const getters = {
  projects(state) {
    return state.projects
  },
  isLoading(state) {
    return state.isLoading
  },
  error(state) {
    return state.error
  },
}

const actions = {
  getProjects({ commit, rootGetters }, data) {
    commit(types.SET_PROJECTS_LOADING);
    return fetch('/users/' + rootGetters['user/profile/id'] + '/memberships' + data.urlParams)
      .then(response => response.json())
      .then((projects) => {
        commit(types.SET_PROJECTS, projects)
        return projects
      })
      .catch((error) => {
        commit(types.SET_PROJECTS_ERROR, error)
      })
  },

  refresh({commit }) {
    commit(types.RESET);
  },
}

const types = {
  SET_PROJECTS_LOADING: 'SET_PROJECTS_LOADING',
  SET_PROJECTS: 'SET_PROJECTS',
  SET_PROJECTS_ERROR: 'SET_PROJECTS_ERROR',
  RESET_ERROR: 'RESET_ERROR',
  RESET: 'RESET',
}
const mutations = {
  [types.SET_PROJECTS_LOADING](state) {
    state.isLoading = true;
  },
  [types.SET_PROJECTS](state, projects) {
    state.projects = projects;
    state.isLoading = false;
  },
  [types.SET_PROJECTS_ERROR](state, error) {
    state.error = error;
    state.isLoading = false;
  },
  [types.RESET_ERROR](state) {
    state.isLoading = false;
    state.error = null;
  },
  [types.RESET](state) {
    Object.assign(state, getInitialState());
  },
}

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}
